/**
 * Axios
 */
import axios from "axios";

/**
 * @call
 */

export const addCall = ({ id, schema }) => {
  // console.log(schema.email);
  return new Promise((resolve, reject) => {
    axios.post(`/file/${id}/call`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const updateCall = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/file/call/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

/**
 * @appointment
 */

export const addAppointment = ({ id, schema }) => {
  // console.log(schema.email);
  return new Promise((resolve, reject) => {
    axios.post(`/file/${id}/appointment`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const updateAppointment = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/file/appointment/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

/**
 * @quoting
 */

export const addQuoting = ({ schema }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/quoting`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const updateQuoting = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/quoting/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const manageWarrantyTable = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/quoting/request/${id}/manage-quoting`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

/**
 * @contract
 */

export const addInvoice = ({ schema }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/invoice`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const invoiceUpdate = ({ schema, id }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.put(`/invoice/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const addContract = ({ schema }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/contract`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const updateContract = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/contract/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
/**
 * @contract
 */

export const addIncorporation = ({ schema, id }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/file/${id}/incorporation`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const withdrawProspect = ({ schema, id }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/file/${id}/withdraw`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

// regulation clause
export const addRegulationClause = ({ schema, id }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/contract/${id}/regulation-clause`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const updateRegulationClause = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/contract/regulation-clause/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

// regulation clause
export const addPbClause = ({ schema, id }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/contract/${id}/pb-clause`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const updatePbClause = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/contract/pb-clause/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

// coinsurance
export const addCoinsurance = ({ schema, id }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/contract/${id}/coinsurance`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const updateCoinsurance = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/contract/${id}/coinsurance`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

// reinsurance
export const addReinsurance = ({ schema, id }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.post(`/contract/${id}/reinsurance`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const updateReinsurance = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/contract/reinsurance/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const getReinsurance = ({ id, contract, insurer }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/contract/reinsurance/${id}?contract=${contract}&insurer=${insurer}`
      )
      .then(
        (res) => {
          resolve(res.data);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

export const createQuotingRequest = ({ schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/quoting/request`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const updateQuotingRequest = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/quoting/request/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const addCompanyReturn = ({ schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/quoting/company-return`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const updateCompanyReturn = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/quoting/company-return/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const manageCustomerReturn = ({ schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/quoting/customer-return`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const manageNotice = ({ schema, id }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/contract/${id}/manage-follow-up-of-renewals`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const cancelContract = ({ id }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/contract/${id}/cancel`).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const createDeclaration = ({ id, receiptNumber, schema, mobileID }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `/sinister/contract/${id ? id : "id="}/declaration?receiptNumber=${
          receiptNumber ? receiptNumber : ""
        }`,
        schema
      )
      .then(
        (res) => {
          resolve(res.data);
          // alert(JSON.stringify(res.data));
          if (receiptNumber != "") {
            const Make = {
              status: "Traité",
              dateOfOccurrence: res.data.data.dateOfOccurrence,
              // location: schema.location,
              sinisterAskNumber: res.data.data.sinisterAskNumber,
            };
            axios
              .put(`/file/declaration-request/${mobileID}/update-status`, Make)
              .then(
                (res) => {
                  resolve(res.data);
                },
                (error) => {
                  reject(error);
                }
              );
          }
        },
        (error) => {
          reject(error);
        }
      );
  });
};
// export const updateMobileDeclaration = ({ id, Make }) => {
//   return new Promise((resolve, reject) => {

//   });
// };
export const updateDeclaration = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/sinister/declaration/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const createVictim = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/sinister/declaration/${id}/victim`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const updateVictim = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/sinister/victim/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const deleteVictim = ({ id }) => {
  return new Promise((resolve, reject) => {
    axios.delete(`/sinister/victim/${id}`).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const manageCoupon = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/sinister/victim/${id}/coupon`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const manageExpertise = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/sinister/victim/${id}/expertise`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const managePv = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/sinister/victim/${id}/pv`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const manageOffer = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/sinister/victim/${id}/offer`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const manageDocumentProposed = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/sinister/victim/${id}/document`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const createGlobalMail = ({ schema }) => {
  return new Promise((resolve, reject) => {
    axios.post(`/global-mail`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
export const updateGlobalMail = ({ id, schema }) => {
  return new Promise((resolve, reject) => {
    axios.put(`/global-mail/${id}`, schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
// profile management
export const updateUsers = ({ schema }) => {
  // console.log(schema.email);

  return new Promise((resolve, reject) => {
    axios.put("/user/profile", schema).then(
      (res) => {
        resolve(res.data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};
